import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { Add, Remove } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  boxShadow: "none",
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
}));

const LanguagesForm = ({ onChildData }) => {
  const [languages, setLanguages] = useState([
    {
      language: "",
      proficiency: "",
    },
  ]);

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updatedLanguages = [...languages];
    updatedLanguages[index][name] = value;
    setLanguages(updatedLanguages);
    onChildData({ languages: updatedLanguages });
  };

  const addLanguage = () => {
    setLanguages([
      ...languages,
      {
        language: "",
        proficiency: "",
      },
    ]);
  };

  const removeLanguage = (index) => {
    const updatedLanguages = languages.filter((_, i) => i !== index);
    setLanguages(updatedLanguages);
    onChildData({ languages: updatedLanguages });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const output = `languages:\n${languages
      .map(
        (lang) =>
          `  - language: "${lang.language}"\n    proficiency: "${lang.proficiency}"`
      )
      .join("\n")}`;

    console.log(output);
    // Process languages as needed
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 3, pt: 0, pb: 2 }}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography variant="h6">Languages</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {languages.map((lang, index) => (
            <Grid container spacing={2} key={index} sx={{ mb: 2 }}>
              <Grid size={12}>
                <Item>
                  <TextField
                    fullWidth
                    label="Language"
                    name="language"
                    placeholder="English"
                    size="small"
                    value={lang.language}
                    onChange={(e) => handleChange(index, e)}
                    required
                  />
                </Item>
              </Grid>
              <Grid item size={10}>
                <FormControl fullWidth required size="small">
                  <InputLabel>Proficiency</InputLabel>
                  <Select
                    name="proficiency"
                    value={lang.proficiency}
                    onChange={(e) => handleChange(index, e)}
                  >
                    <MenuItem value="">
                      <em>Select proficiency...</em>
                    </MenuItem>
                    <MenuItem value={"0 - No proficiency"}>0 - No proficiency</MenuItem>
                    <MenuItem value={"1 - Elementary proficiency"}>1 - Elementary proficiency</MenuItem>
                    <MenuItem value={"2 - Limited working proficiency"}>
                      2 - Limited working proficiency
                    </MenuItem>
                    <MenuItem value={"3 - Professional working proficiency"}>
                      3 - Professional working proficiency
                    </MenuItem>
                    <MenuItem value={"4 - Full professional proficiency"}>
                      4 - Full professional proficiency
                    </MenuItem>
                    <MenuItem value={"5 - Primary fluency / bilingual proficiency"}>
                      5 - Primary fluency / bilingual proficiency
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid size={2}>
                <IconButton onClick={() => removeLanguage(index)} color="error">
                  <DeleteForeverIcon />
                </IconButton>
              </Grid>
            </Grid>
          ))}
          <Button
            variant="outlined"
            onClick={addLanguage}
            startIcon={<Add />}
            sx={{ mb: 2 }}
          >
            Add Language
          </Button>
          <div>
            <small>
              <a
                href="https://www.indeed.com/career-advice/resumes-cover-letters/levels-of-fluency-resume"
                target="_blank"
                rel="noreferrer"
              >
                See Details
              </a>
            </small>
          </div>
        </AccordionDetails>
      </Accordion>

      <Box>
        <Button type="submit" sx={{ display: "none" }} variant="contained">
          Submit
        </Button>
      </Box>
    </Box>
  );
};

export default LanguagesForm;
